import { Tab } from "@headlessui/react";

function TabPanel({ children }) {
  return <Tab.Panel>{children}</Tab.Panel>;
}

export default TabPanel;
